// Load Bootstrap JS
import bootstrap from 'bootstrap'
import $ from "jquery";
// Load Styles
import '../scss/main.scss';

$(window).on('load', function() {
    $('.fixed-top a[href^="#"]').on('click', function(event) {
        var target = $( $(this).attr('href') );
    
        if( target.length ) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 500);
        }
        if ($(document).width() <= 767) {
            $('.navbar-toggler').addClass('collapsed').attr('aria-expanded', 'false');
            $("#nav-main").removeClass("show");
        }
    
    });
});

$(window).on('scroll', function(){
    var sticky = $('.fixed-top'),
    scroll = $(window).scrollTop();

    if (scroll >= 50) {
        sticky.addClass('bg-light');
        $('.navbar-brand img').addClass('logoanima');
    }else {
        sticky.removeClass('bg-light');
        $('.navbar-brand img').removeClass('logoanima');
    }
});


$('#FrmEnviar').on('submit', function(e) {
    e.preventDefault();
    console.log($('#FrmEnviar').serialize());
    $.ajax({
        type: 'POST',
        url: 'enviar.php',
        data: $('#FrmEnviar').serialize(),
        success: function(result) {
            document.getElementById("FrmEnviar").reset();
            $("#resp").html(result);
        }
    });
    return false;
});